import React from "react";

import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";

import AccountingFilterApplyButton from "./AccountingFilterApplyButton";



const AccountingReportFilters = ({

  branches,

  periods,

  branchId,

  setBranchId,

  periodId,

  setPeriodId,

  dateFrom,

  setDateFrom,

  dateTo,

  setDateTo,

  usePeriod,

  setUsePeriod,

  onApply,

  loading,

}) => (

  <div className="card mb-3">

    <div className="card-body">

      <Row className="g-3 align-items-end">

        <Col md="2">

          <FormGroup className="mb-0">

            <Label>Branch</Label>

            <Input type="select" value={branchId} onChange={(e) => setBranchId(e.target.value)}>

              <option value="">All branches</option>

              {branches.map((b) => (

                <option key={b.id} value={b.id}>{b.name}</option>

              ))}

            </Input>

          </FormGroup>

        </Col>

        <Col md="2">

          <FormGroup className="mb-0">

            <Label>Filter by</Label>

            <Input type="select" value={usePeriod ? "period" : "dates"} onChange={(e) => setUsePeriod(e.target.value === "period")}>

              <option value="period">Financial period</option>

              <option value="dates">Date range</option>

            </Input>

          </FormGroup>

        </Col>

        {usePeriod ? (

          <Col md="3">

            <FormGroup className="mb-0">

              <Label>Period</Label>

              <Input type="select" value={periodId} onChange={(e) => setPeriodId(e.target.value)}>

                <option value="">Select period</option>

                {periods.map((p) => (

                  <option key={p.id} value={p.id}>{p.name} ({p.status})</option>

                ))}

              </Input>

            </FormGroup>

          </Col>

        ) : (

          <>

            <Col md="2">

              <FormGroup className="mb-0">

                <Label>From</Label>

                <Input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />

              </FormGroup>

            </Col>

            <Col md="2">

              <FormGroup className="mb-0">

                <Label>To</Label>

                <Input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />

              </FormGroup>

            </Col>

          </>

        )}

        <AccountingFilterApplyButton onClick={onApply} loading={loading} />

      </Row>

    </div>

  </div>

);



export default AccountingReportFilters;


